<template>
  <v-row class="info-card" dense no-gutters>
<!--    <div class="info-card__field" v-for="(value, name, index) in data" :key="index">
      <div class="info-card__name">
        <slot name="name" :row="value"> {{ name }}:</slot>
      </div>
      <div class="info-card__cell">
        <slot name="value" :row="value"> {{ value }}</slot>
      </div>
    </div>-->
    <v-col
        class="info-card__field"
        :class="{'pr-3': cols !== 12 && (index +1) !== data.length}"
        v-for="({value, name, cols}, index) in data"
        :key="index"
        :cols="cols"
    >
      <div class="info-card__name">
        <slot name="name" :row="name"> {{ name }}:</slot>
      </div>
      <div class="info-card__cell">
        <slot name="value" :row="value"> {{ value }}</slot>
      </div>
    </v-col>
  </v-row>
</template>
<script>
export default {
  props: {
    data: {
      type: [Object, Array],
    }
  }
}
</script>
<style lang="sass" scoped>
.info-card
  .info-card__name
    color: #455058
    font-size: 16px
    margin: 5px
    white-space: nowrap
    overflow: hidden
    text-overflow: ellipsis
    line-height: 18.75px
    font-weight: 400
  //
  .info-card__cell
    background: #E3EFFA
    padding: 8px
    border-radius: 7px
    flex-grow: 1
    font-size: 16px
    color: #455058
    line-height: 18.75px
    min-height: 36px
  //
  //.info-card__field
  //  display: flex
  //  align-items: center
  //  margin-bottom: 14px
  //
  //.info-card__button
  //  margin-top: 10px
  //  margin-left: 10px
</style>
